<div class="container-xxl container-fluid gx-0 position-relative">
    @if (!isPlaying) {
        <div class="background-image" [style.background-image]="'url(' + backgroundImage + ')'">
            @if (!isPlaying) {
                <div class="background-image__text">
                    <h2 class="fs-24 fs-sm-39 fs-md-57 text-white fw-700 lh-38 w-80 w-sm-65 w-lg-60 w-xl-50 mb-2">
                        {{ (title ? title : '') | translate }}
                    </h2>
                    <button type="submit" (click)="playVideo()" class="btn-play d-flex align-items-center btn fs-24 opacity-75 p-0 mt-5">
                        <div class="pe-1">
                            <span class="fs-14 fw-600">{{ btnText | translate }}</span
                            ><span></span>
                        </div>
                        <div class="icon icon-s icon-white ml-5">
                            <svg
                                aria-hidden="true"
                                focusable="false"
                                data-icon="play-icon"
                                role="img"
                                xmlns="http://www.w3.org/2000/svg"
                                xmlns:xlink="http://www.w3.org/1999/xlink"
                                viewBox="0 0 460.114 460.114"
                            >
                                <g>
                                    <g>
                                        <path
                                            d="M393.538,203.629L102.557,5.543c-9.793-6.666-22.468-7.372-32.94-1.832c-10.472,5.538-17.022,16.413-17.022,28.26v396.173c0,11.846,6.55,22.721,17.022,28.26c10.471,5.539,23.147,4.834,32.94-1.832l290.981-198.087c8.746-5.954,13.98-15.848,13.98-26.428C407.519,219.477,402.285,209.582,393.538,203.629z"
                                        />
                                    </g>
                                </g>
                            </svg>
                        </div>
                    </button>
                </div>
            }
        </div>
    }

    @if (isPlaying) {
        <video #video (ended)="videoEnded()" class="background-video" controls autoplay disablepictureinpicture controlslist="nodownload noplaybackrate">
            @for (video of videos; track video) {
                <source src="{{ video }}" type="video/mp4" />
            }
        </video>
    }
</div>
